"use strict";
/* eslint-disable no-shadow */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalServices = exports.OrganizationalRoles = exports.UserUseCases = exports.UserDepartmentPositions = exports.UserResponsibilities = exports.UserCreationMethods = exports.DefaultScreens = exports.ChampionLevels = exports.Roles = exports.UiLocales = exports.Pronouns = void 0;
/**
 * The customers-management service uses the following enums to update the DB schema.
 * IMPORTANT: Any change to these enums should be followed by a library update in the service and deployment,
 * otherwise new values will not be supported by the DB schema.
 */
var Pronouns;
(function (Pronouns) {
    Pronouns["SHE"] = "she";
    Pronouns["HE"] = "he";
    Pronouns["THEY"] = "they";
})(Pronouns = exports.Pronouns || (exports.Pronouns = {}));
var UiLocales;
(function (UiLocales) {
    UiLocales["ENGLISH"] = "en";
    UiLocales["HEBREW"] = "he";
    UiLocales["FRENCH"] = "fr";
    UiLocales["SPANISH"] = "es";
})(UiLocales = exports.UiLocales || (exports.UiLocales = {}));
var Roles;
(function (Roles) {
    Roles["GROUP_ADMIN"] = "groupAdmin";
    Roles["CLIENT_STAFF"] = "clientStaff";
    Roles["CLIENT_ADMIN"] = "clientAdmin";
    Roles["ZENCITY_SUPERADMIN"] = "superadmin";
    Roles["ZENCITY_ANNOTATOR"] = "annotator";
    Roles["ZENCITY_CUSTOMER_SOLUTIONS"] = "customerSolutions";
})(Roles = exports.Roles || (exports.Roles = {}));
var ChampionLevels;
(function (ChampionLevels) {
    ChampionLevels["CHAMPION"] = "champion";
    ChampionLevels["PIPELINE_CHAMPION"] = "pipeline-champion";
    ChampionLevels["REGULAR"] = "regular";
})(ChampionLevels = exports.ChampionLevels || (exports.ChampionLevels = {}));
var DefaultScreens;
(function (DefaultScreens) {
    DefaultScreens["HOME_SCREEN"] = "home-screen";
    DefaultScreens["CONSOLE"] = "console";
    DefaultScreens["COMMUNITY_SURVEYS_FEED"] = "community-survey-feed";
    DefaultScreens["BLOCKWISE"] = "blockwise";
    DefaultScreens["ORGANIC_DASHBOARD"] = "organic";
    DefaultScreens["ORGANIC_PROJECTS"] = "organic-projects";
    DefaultScreens["ORGANIC_NEWS_FEED"] = "organic-news-feed";
    DefaultScreens["ENGAGE"] = "engage";
    DefaultScreens["GOVFLOW"] = "govflow";
})(DefaultScreens = exports.DefaultScreens || (exports.DefaultScreens = {}));
var UserCreationMethods;
(function (UserCreationMethods) {
    UserCreationMethods["INVITED_BY_ZENCITY_STAFF"] = "invited-by-zencity-staff";
    UserCreationMethods["INVITED_BY_ZENCITY_STAFF_BULK"] = "invited-by-zencity-staff-bulk";
    UserCreationMethods["CREATED_BY_ZENCITY_STAFF_BULK"] = "created-by-zencity-staff-bulk";
    UserCreationMethods["INVITED_BY_CLIENT_ADMIN"] = "invited-by-client-admin";
})(UserCreationMethods = exports.UserCreationMethods || (exports.UserCreationMethods = {}));
var UserResponsibilities;
(function (UserResponsibilities) {
    UserResponsibilities["POLICY"] = "policy";
    UserResponsibilities["BUDGET_SPENDING"] = "budget-spending";
    UserResponsibilities["COUNCIL_MEETINGS"] = "council-meetings";
    UserResponsibilities["MEETINGS_WITH_MANAGEMENT"] = "meetings-with-management";
    UserResponsibilities["STRATEGIC_PROJECTS"] = "strategic-projects";
    UserResponsibilities["MEDIA_MONITORING"] = "media-monitoring";
    UserResponsibilities["MESSAGES_CAMPAIGNS"] = "messages-campaigns";
    UserResponsibilities["ANALYSIS_REPORTS_FOR_MANAGEMENT"] = "analysis-reports-for-management";
    UserResponsibilities["CITIZEN_PARTICIPATION"] = "citizen-participation";
    UserResponsibilities["CONTACT_CITIZENS"] = "contact-citizens";
    UserResponsibilities["LEGISLATIVE"] = "legislative";
    UserResponsibilities["ELECTED_OFFICIAL"] = "elected-official";
    UserResponsibilities["OTHER"] = "other";
})(UserResponsibilities = exports.UserResponsibilities || (exports.UserResponsibilities = {}));
var UserDepartmentPositions;
(function (UserDepartmentPositions) {
    UserDepartmentPositions["HEAD"] = "head";
    UserDepartmentPositions["DEPUTY_HEAD"] = "deputy-head";
    UserDepartmentPositions["CONSULTANT"] = "consultant";
    UserDepartmentPositions["TEAM_MEMBER"] = "team-member";
})(UserDepartmentPositions = exports.UserDepartmentPositions || (exports.UserDepartmentPositions = {}));
var UserUseCases;
(function (UserUseCases) {
    UserUseCases["TOP_POLICY_MAKER"] = "top-policy-maker";
    UserUseCases["MANAGEMENT"] = "management";
    UserUseCases["COMMUNICATION"] = "communication";
    UserUseCases["ANALYST_RESEARCHER"] = "analyst-researcher";
    UserUseCases["COMMUNITY_ENGAGEMENT"] = "community-engagement";
    UserUseCases["ELECTED_OFFICIAL"] = "elected-official";
    UserUseCases["HEAD_OF_PROGRAM"] = "head-of-program";
    UserUseCases["PROGRAM_COORDINATOR"] = "program-coordinator";
    UserUseCases["PROGRAM_MANAGER_OFFICER"] = "program-manager-officer";
    UserUseCases["EXECUTIVE_ASSISTANT"] = "executive-assistant";
})(UserUseCases = exports.UserUseCases || (exports.UserUseCases = {}));
var OrganizationalRoles;
(function (OrganizationalRoles) {
    OrganizationalRoles["MAYOR"] = "mayor";
    OrganizationalRoles["CITY_MANAGER"] = "city-manager";
    OrganizationalRoles["ASSISTANT_CITY_MANAGER"] = "assistant-city-manager";
    OrganizationalRoles["COUNCIL_MEMBER"] = "council-member";
    OrganizationalRoles["COUNTY_ADMINISTRATOR"] = "county-administrator";
    OrganizationalRoles["COUNTY_EXECUTIVE"] = "county-executive";
    OrganizationalRoles["COUNTY_MANAGER"] = "county-manager";
    OrganizationalRoles["COUNTY_MAYOR"] = "county-mayor";
    OrganizationalRoles["DEPUTY_COUNTY_ADMINISTRATOR"] = "deputy-county-administrator";
    OrganizationalRoles["SHERIFF"] = "sheriff";
    OrganizationalRoles["POLICE_CHIEF"] = "police-chief";
    OrganizationalRoles["HEAD_OF_STATE_AGENCY"] = "head-of-state-agency";
    OrganizationalRoles["DIRECTOR"] = "director";
    OrganizationalRoles["HEAD_OF_DEPARTMENT"] = "head-of-department";
    OrganizationalRoles["DEPUTY_HEAD_OF_DEPARTMENT"] = "deputy-head-of-department";
    OrganizationalRoles["HEAD_OF_PROGRAM"] = "head-of-program";
    OrganizationalRoles["PROGRAM_COORDINATOR"] = "program-coordinator";
    OrganizationalRoles["PROGRAM_MANAGER_OFFICER"] = "program-manager-officer";
    OrganizationalRoles["EXTERNAL_CONSULTANT"] = "external-consultant";
    OrganizationalRoles["EXECUTIVE_ASSISTANT"] = "executive-assistant";
    OrganizationalRoles["PATROL_FIELD_OFFICER"] = "patrol-field-officer";
    OrganizationalRoles["TEAM_MEMBER"] = "team-member";
    OrganizationalRoles["OTHER"] = "other";
})(OrganizationalRoles = exports.OrganizationalRoles || (exports.OrganizationalRoles = {}));
var ExternalServices;
(function (ExternalServices) {
    ExternalServices["AMPLITUDE"] = "amplitude";
    ExternalServices["SALESFORCE"] = "salesforce";
    ExternalServices["ENGAGE"] = "engage";
})(ExternalServices = exports.ExternalServices || (exports.ExternalServices = {}));
